import { useGlobalState } from './globalState';
export function useSharedData(s) {
    const select = s || ((m) => m);
    return useGlobalState((s) => select(s.data));
}
//# sourceMappingURL=sharedData.js.map